import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);

const baseService = createCrudService("cbsPrograms", [], router);

export const cbsProgramsService = {
  ...baseService,

  getClients: async (programId) => {
    return api.getCall(`/api/cbsPrograms/${programId}/clients`);
  },

  addClient: async (programId, clientId) => {
    return api.postCall(`/api/cbsPrograms/${programId}/clients`, { clientId });
  },

  removeClient: async (programId, clientId) => {
    return api.deleteCall(`/api/cbsPrograms/${programId}/clients/${clientId}`);
  },
};
